// Autogenerated file
import Footer from './Footer.json';

export default {
  ...Footer,
};
